export const environment = {
  production: true,
  buildId: '3992064178124171',
  configFile: 'config.json',
};
